<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'create-winner-modal'"
    @hidden="$bvModal.hide('create-winner-modal')"
    @show="() => {}"
  >
    <b-form @submit.prevent="onSubmitModal">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="information-header font-weight-bolder text-black">
            Add Winner
          </div>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-12 pl-3 pr-3">
          <div class="font-Information font-weight-bolder text-black">
            Information
          </div>
          <div class="font-medium-5">กรุณากรอกข้อมูลลูกค้า</div>

          <div class="row mb-1 mt-2">
            <div class="col-12">
              <b-form-group
                :label="'First Name'"
                label-for="firstName"
                label-class="font-medium-5 required"
              >
                <b-form-input
                  id="firstName"
                  v-model="formData.firstName"
                  :placeholder="'ระบุ'"
                  required
                />
              </b-form-group>
            </div>
            <div class="col-12">
              <b-form-group
                :label="'Last Name'"
                label-for="lastName"
                label-class="font-medium-5 required"
              >
                <b-form-input
                  id="lastName"
                  v-model="formData.lastName"
                  :placeholder="'ระบุ'"
                  required
                />
              </b-form-group>
            </div>
            <div class="col-12">
              <b-form-group
                :label="'Mobile No'"
                label-for="mobileNo"
                label-class="font-medium-5 required"
              >
                <b-form-input
                  id="mobileNo"
                  :formatter="formatMobileNo"
                  v-model="formData.mobileNo"
                  :placeholder="'ตัวอย่าง 0833333333'"
                  :state="formData.mobileNo && formData.mobileNo.length == 10"
                  required
                />
              </b-form-group>
            </div>

            <div class="col-12">
              <b-form-group
                :label="'Address'"
                label-for="address"
                label-class="font-medium-5"
              >
                <b-form-textarea
                  id="desc"
                  v-model="formData.address"
                  :placeholder="'ระบุ'"
                  no-resize
                  rows="3"
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                :btnLabel="'Back'"
                :stageBack="true"
                @click.native="$emit('onCloseModal')"
              />
              <save-button class="ml-1" type="submit" :disabled="hasMobile" />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import useCreateWinnerModal from "./hooks/useCreateWinnerModal";
export default {
  props: {
    isEdit: { type: Boolean, default: false },
    formDataObj: { type: [Object, Array], default: null },
  },
  setup(props) {
    const formatMobileNo = (e) => {
      const num = e.replace(/\D/g, "").substring(0, 10);
      return num;
    };
    const { formData, onSubmitModal, hasMobile } = useCreateWinnerModal(props);

    return { formData, onSubmitModal, formatMobileNo, hasMobile };
  },
};
</script>

<style>
.modal .modal-header {
  display: none;
}

.modal-content {
  border-radius: 1.6rem;
}
</style>

<style scoped>
#create-winner-modal .information-header {
  border-bottom: 1px solid #ececec;
  padding: 5px 15px 10px;
  font-size: 1.8rem !important;
  width: 100%;
}

.font-Information {
  font-size: 1.8rem;
}
</style>
